import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca24afe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["textContent"]
const _hoisted_2 = { class: "flexbox" }
const _hoisted_3 = { class: "videoMsg" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["poster", "src"]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = {
  key: 0,
  class: "list"
}
const _hoisted_8 = { class: "ul-box" }
const _hoisted_9 = ["onClick", "id"]
const _hoisted_10 = { class: "pic" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("em"),
  /*#__PURE__*/_createElementVNode("em"),
  /*#__PURE__*/_createElementVNode("em")
], -1))
const _hoisted_13 = ["textContent"]
const _hoisted_14 = ["title", "textContent"]
const _hoisted_15 = ["textContent"]

import imgPH from "@/assets/images/ph_16_9.png";
import { computed, ref, reactive, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import videos from "@/views/Video/Videos";

export default /*#__PURE__*/_defineComponent({
  __name: 'Info',
  setup(__props) {

const language = computed(() => store.state.appLanguage);
const route = useRoute();
const router = useRouter();
const store = useStore();
const isMobile = computed(() => !!store.state.isMobile);
const videoLists = reactive(videos);
const activeInfo = ref(videoLists[0]);
const init = () => {
  videoLists.map((item) => {
    if (item.id.toString() === route.params.id) {
      item.isPlay = true;
      activeInfo.value = item;
      try {
        document.querySelector(".ul-box").scrollTop = (
          document.querySelector("#id" + route.params.id) as HTMLElement
        ).offsetTop;
      } catch (e) {}
    } else {
      item.isPlay = false;
    }
  });
};
onMounted(() => {
  init();
});

const back = () => {
  router.push({
    name: "helpVideo",
  });
};
const triggerClick = (i: number) => {
  videoLists.map((item, index) => {
    item.isPlay = false;
    if (i === index) {
      item.isPlay = true;
      activeInfo.value = item;
    }
  });
  if (activeInfo.value.platform === "video") {
    setTimeout(() => {
      const myVideoContent: HTMLVideoElement = document.getElementById(
        "myvideo"
      ) as HTMLVideoElement;
      myVideoContent && myVideoContent.play();
    }, 1000);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['box', { mobileSize: _unref(isMobile) }])
  }, [
    _createElementVNode("h2", {
      class: "mainTitle",
      textContent: _toDisplayString(_unref(language) === 'zh' ? activeInfo.value.title : activeInfo.value.titleEn)
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (activeInfo.value.platform === 'bilibili')
          ? (_openBlock(), _createElementBlock("iframe", {
              key: 0,
              src: activeInfo.value.src,
              scrolling: "no",
              border: "0",
              frameborder: "no",
              framespacing: "0",
              allowfullscreen: "true",
              class: "w-lightbox-embed"
            }, "\n        ", 8, _hoisted_4))
          : _createCommentVNode("", true),
        (activeInfo.value.platform === 'video')
          ? (_openBlock(), _createElementBlock("video", {
              key: 1,
              id: "myvideo",
              poster: activeInfo.value.poster,
              src: activeInfo.value.src,
              controls: ""
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true),
        (_unref(isMobile))
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "more",
              onClick: back,
              textContent: _toDisplayString(_ctx.$t('videoInfo.backToList'))
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      (!_unref(isMobile))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoLists, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass({ active: item.isPlay }),
                  onClick: ($event: any) => (triggerClick(index)),
                  id: 'id' + (index + 1)
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("img", {
                      src: _unref(imgPH),
                      style: _normalizeStyle(`background-image:url(${item.poster})`)
                    }, null, 12, _hoisted_11),
                    _hoisted_12,
                    _createElementVNode("span", {
                      class: "duration",
                      textContent: _toDisplayString(item.duration)
                    }, null, 8, _hoisted_13)
                  ]),
                  _createElementVNode("div", {
                    class: "tit",
                    title: _unref(language) === 'zh' ? item.title : item.titleEn,
                    textContent: _toDisplayString(_unref(language) === 'zh' ? item.title : item.titleEn)
                  }, null, 8, _hoisted_14)
                ], 10, _hoisted_9))
              }), 256))
            ]),
            _createElementVNode("div", {
              class: "more",
              onClick: back,
              textContent: _toDisplayString(_ctx.$t('videoInfo.backToList'))
            }, null, 8, _hoisted_15)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})